import UserService from "../services/user/UserService";
import { useRef, useState, useEffect, FormEvent } from "react";
import IUser from "../models/user";
import Auth from "../services/auth/AuthService";
import { defaultLanguage, languages } from "../i18n";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AuthService from "../services/auth/AuthService";

export type stateType = {
    from: { pathname: string };
};


const useLogin = () => {
    const { t, i18n } = useTranslation();

    const userRef = useRef<HTMLInputElement>(null);
    const errRef = useRef<HTMLParagraphElement>(null);

    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [username, setUsername] = useState("");
    const [pwd, setPwd] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(true);

    const [isEmptyField, setIsEmptyField] = useState(true);
    const [isValidEmail, setIsValidEmail] = useState(true);

    useEffect(() => {
        if (AuthService.guid) window.location.href = "/";
    }, []);

    useEffect(() => {
        userRef.current?.focus();
    }, []);

    useEffect(() => {
        setErrMsg("");
    }, [username, pwd]);

    useEffect(() => {
        setIsEmptyField((username == "") || (pwd == ""));
        setIsValidEmail(!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/.test(username));
    }, [username, pwd]);

    const onSubmit = async (e: FormEvent) => {
        setIsLoading(true);
        e.preventDefault();

        UserService.PostLogin(username, pwd)
            .then((req) => req.data)
            .then(async (guid) => {
                if (!guid) {
                    setIsAlert(true);
                    if (isEmptyField) {
                        setAlertMessage(t("login.errorEmptyField"));
                    }
                    else if (isValidEmail) {
                        setAlertMessage(t("login.errorInvalidEmail"));
                    }
                    else {
                        setAlertMessage(t("login.error"));
                    }
                    return;
                }
                const successCallback = (user: IUser) => {
                    setUsername("");
                    setPwd("");

                    window.location.href = "/";
                    return;
                };
                await saveUser(guid, successCallback);
            })
            .catch((e) => {
                setErrMsg(e.response?.data as string);
            })
            .finally(() => setIsLoading(false));
    };

    const saveUser = async (guid: string, successCallback: Function) => {
        const user = await UserService.GetUserByGuid(guid);
        if (user && isChecked) {
            Auth.setAuth(user);
            const lang = languages.get(user.language) ?? languages.get(defaultLanguage);
            i18n.changeLanguage(lang);
            moment.locale(lang);
        }

        successCallback(user);
    };

    return {
        username,
        setUsername,
        pwd,
        setPwd,
        errMsg,
        userRef,
        errRef,
        onSubmit,
        isLoading,
        isAlert,
        setIsAlert,
        alertMessage,
        setAlertMessage,
        isChecked,
        setIsChecked,
    };
};

export default useLogin;
